import { Expose, Exclude } from 'class-transformer';

@Exclude()
export class Mating {
  @Expose()
  category: string;

  @Expose()
  animalId: number;

  @Expose()
  animalLpid: string;

  @Expose()
  matingId: number;

  @Expose()
  mateEweId: number;

  @Expose()
  mateEweLpid: string;

  @Expose()
  mateDate: Date;

  @Expose()
  mateSireId: number;

  @Expose()
  mateSireLpid: string;

  @Expose()
  mateSyndicateLpid: string;

  @Expose()
  mateGroup: string;

  @Expose()
  mateSubGroup: number;

  @Expose()
  mateMethod: string;

  @Expose()
  pharm: string;

  @Expose()
  natPharm: string;

  @Expose()
  ramInDate: Date;

  @Expose()
  ramOutDate: Date;

  @Expose()
  preJoinDate: Date;

  @Expose()
  preJoinEweWt: number;

  @Expose()
  preJoinCondScore: number;

  @Expose()
  backupSireId: number;

  @Expose()
  backupSireLpid: string;

  @Expose()
  backupSyndicateLpid: string;

  @Expose()
  backupInDate: Date;

  @Expose()
  backupOutDate: Date;

  @Expose()
  outcomeEweFateCode: string;

  @Expose()
  outcomeEweFateDate: Date;

  @Expose()
  scanDate: Date;

  @Expose()
  scanGroup: number;

  @Expose()
  scanOp: string;

  @Expose()
  scanResult: string;

  @Expose()
  feedMulti: string;

  @Expose()
  fetalAge: number;

  @Expose()
  maternalBehaviour: number;

  @Expose()
  weaningWetDry: string;

  @Expose()
  weaningWetDryDate: Date;

  @Expose()
  recordValidationStatus: number;

  @Expose()
  sourceSystemId: number;

  @Expose()
  sourceCode: string;

  @Expose()
  submissionId: number;
}
